import React from 'react'

import { Typography } from 'src/storybook/components'
import StyledTag from 'src/storybook/components/StyledTag'

type TVariant = 'bead' | 'tag'

export const ListNumber = ({
  index,
  variant = 'bead',
  style = {},
}: {
  index: number
  variant?: TVariant
  style?: React.CSSProperties
}) => {
  if (variant === 'bead')
    return (
      <div
        style={{
          marginTop: 8,
          borderRadius: 9,
          background: '#595959',
          minHeight: 18,
          minWidth: 18,
          height: 18,
          width: 18,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          ...style,
        }}
      >
        <Typography
          variant="body-12"
          weight="semi-bold"
          style={{
            color: 'white',
          }}
        >
          {index}
        </Typography>
      </div>
    )

  if (variant === 'tag') return <StyledTag $bold>{index}</StyledTag>

  return null
}
